import React, { useEffect, useContext } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ReactSVG } from 'react-svg';
import { AuthContext } from '../../context/auth';
import isEmpty from '../../validation/is-empty';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import './NotFound.scss';

library.add(faQuestionCircle);

function NotFound({ setShowNavbar }) {
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const canGoBack = history.length > 2 ? true : false;
  
  useEffect(() => {
    // navigator.vibrate([500, 500, 500]);
    if (!isEmpty(setShowNavbar)) setShowNavbar(false);
    return () => {
      if (!isEmpty(setShowNavbar)) setShowNavbar(true);
      document.title = 'Facti';
    };
  }, []);

  return (
    <Route
      render={({ staticContext }) => {
        if (staticContext) {
          staticContext.status = 404
          return;
        }
        return (
          <div id="_not-found_">
           <HelmetProvider>
            <Helmet>
              <title>No se encontró esta página - Facti</title>
              <link
                href="https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap"
                rel="stylesheet"
              ></link>
            </Helmet>
           </HelmetProvider>
            <div className="container">
              <header className="header">
                <div className="row no-margin">
                  <div className="col-6">
                    <ReactSVG
                      wrapper="span"
                      src="/assets/img/facti-new-logo (blue).svg"
                      fallback={() => <span>Facti - logo</span>}
                      afterInjection={(error, svg) => {
                        if (error) return;
                        svg.removeAttribute('data-src');
                      }}
                    />
                  </div>
                  <div className="col-6 help" style={{ textAlign: 'right' }}>
                    <a rel="preload" href="https://ayuda.facti.mx">
                      <FontAwesomeIcon icon={['far', 'question-circle']} />
                      Ayuda
                    </a>
                  </div>
                </div>
              </header>
              <div id="content" className="valign-wrapper">
                <div className="row no-margin valign">
                  <div className="col-12">
                    <ReactSVG
                      wrapper="span"
                      src="/assets/img/404 - 2.svg"
                      fallback={() => <span>404 - Not Found</span>}
                      afterInjection={(error, svg) => {
                        if (error) return;
                        svg.removeAttribute('data-src');
                        svg.setAttribute('id', '404');
                      }}
                    />
                  </div>
                  <div className="col-12">
                    <h2>Oops! Esta página no existe.</h2>
                    <p id="msg">
                      Es posible que el enlace que has seguido sea incorrecto o
                      que se haya eliminado la página.
                    </p>

                    <p id="options">Aquí algunos enlaces útiles:</p>
                    <div id="menu" className="row no-margin">
                      {canGoBack && (
                        <div className="col-6">
                          <a
                            href="/"
                            onClick={(e) => {
                              e.preventDefault();
                              history.goBack();
                            }}
                          >
                            Regresar
                          </a>
                        </div>
                      )}
                      <div className="col-6">
                        <a rel="preload" href="https://www.facti.mx">
                          Sitio Web
                        </a>
                      </div>
                      {!canGoBack && (
                        <div className="col-6">
                          <a rel="preload" href="https://blog.facti.mx">
                            Blog
                          </a>
                        </div>
                      )}
                      <div className="col-6">
                        {/* 
                          <a rel="preload" href="https://www.facti.io">
                            {isEmpty(user) ? 'Inicia sesión' : 'Inicio / Home'}
                          </a>
                        */}
                        <a rel="preload" href="https://www.facti.mx/login">
                          Inicia sesión
                        </a>
                      </div>
                      {canGoBack && !isEmpty(user) ? (
                        <div className="col-6">
                          <a rel="preload" href="https://blog.facti.mx">
                            Blog
                          </a>
                        </div>
                      ) : (
                        <div className="col-6">
                          {/*
                            <a rel="preload" href="https://www.facti.io/register">
                              Regístrate
                            </a>
                          */}
                          <a rel="preload" href="https://www.facti.mx/signup">
                            Regístrate
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    />
  );
}

export default NotFound;
